import { cn } from '../utilitarios/cn'

const TAMANHOS = {
  sm: 'h-7 w-7 text-[0.625rem]',
  md: 'h-9 w-9 text-xs',
  lg: 'h-12 w-12 text-sm',
  xl: 'h-20 w-20 text-xl',
} as const

export interface PropriedadesAvatar {
  nome: string
  fotoUrl?: string | null
  tamanho?: keyof typeof TAMANHOS
  className?: string
}

/** Iniciais quando não há foto: duas letras, primeira e última palavra do nome. */
export function iniciaisDe(nome: string): string {
  const partes = nome.trim().split(/\s+/).filter(Boolean)
  if (partes.length === 0) return '?'
  const primeira = partes[0]?.[0] ?? ''
  const ultima = partes.length > 1 ? (partes[partes.length - 1]?.[0] ?? '') : ''
  return (primeira + ultima).toUpperCase()
}

export function Avatar({ nome, fotoUrl, tamanho = 'md', className }: PropriedadesAvatar) {
  if (fotoUrl) {
    return (
      <img
        src={fotoUrl}
        alt={nome}
        className={cn(
          'shrink-0 rounded-full object-cover ring-1 ring-borda',
          TAMANHOS[tamanho],
          className,
        )}
      />
    )
  }

  return (
    <span
      aria-hidden="true"
      title={nome}
      className={cn(
        'inline-flex shrink-0 select-none items-center justify-center rounded-full bg-marca-100 font-semibold text-marca-700 ring-1 ring-marca-200',
        TAMANHOS[tamanho],
        className,
      )}
    >
      {iniciaisDe(nome)}
    </span>
  )
}
